<template>
    <div>
        <div class="title" :style="getTitleStyle()">
            {{ myObj.photo_classify_params.title }}
        </div>
        <div class="list-box" :style="getListBoxStyle()">
            <div v-for="(item, index) in myObj.component_source.params.total" :key="index" :style="getItemStyle()"
                class="item">
                <div class="name">
                    <div class="gls"></div>
                    <span>名称</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PhotoClassifyView",
    props: ['obj'],
    data() {
        return {
            myObj: this.obj
        }
    },
    methods: {
        getTitleStyle() {
            return 'margin-left: ' + this.obj.photo_classify_params.margin + 'px;';
        },
        getListBoxStyle() {
            return 'padding-left: ' + this.obj.photo_classify_params.margin + 'px;' +
                'gap:' + this.obj.photo_classify_params.between_space + 'px;' +
                'padding-bottom: ' + this.obj.photo_classify_params.margin + 'px;';
        },
        getItemStyle() {
            const width = Math.floor((375 - this.obj.photo_classify_params.margin * 2
                - (this.obj.photo_classify_params.column - 1) * this.obj.photo_classify_params.between_space)
                / this.obj.photo_classify_params.column);
            const height = width * this.obj.photo_classify_params.item_height_ratio / 100;
            return 'width:' + width + "px;" +
                'height:' + height + "px;" +
                'border-radius:' + this.obj.photo_classify_params.corner_radius + "px;"
        }
    }
}
</script>

<style scoped lang="less">
.title {
    color: black;
    font-size: medium;
    margin-left: 15px;
    line-height: 40px;
}

.list-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
}

.item {
    position: relative;
    background-color: #D8D8D8;

    .name {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: white;

        .gls {
            background-color: rgb(175, 173, 173);
            filter: blur(2px);
            width: 100%;
            height: 100%;
        }

        span {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
        }
    }
}
</style>